import { render } from "./ParticipantRole.vue?vue&type=template&id=497ee724&ts=true"
import script from "./ParticipantRole.vue?vue&type=script&lang=ts"
export * from "./ParticipantRole.vue?vue&type=script&lang=ts"

import "./ParticipantRole.vue?vue&type=style&index=0&id=497ee724&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__